import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface DataTransformConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const DataTransformConfig: React.FC<DataTransformConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Adatátalakítás">
        <ConfigField
          label="Átalakítás típusa"
          description="Milyen átalakítást végezzen"
        >
          <select
            value={node.data.config?.transformationType || 'map'}
            onChange={(e) => updateConfig('transformationType', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="map">Mező leképezés</option>
            <option value="flatten">Lapítás</option>
            <option value="group">Csoportosítás</option>
            <option value="pivot">Pivot</option>
            <option value="aggregate">Aggregálás</option>
          </select>
        </ConfigField>

        {node.data.config?.transformationType === 'map' && (
          <ConfigField
            label="Mező leképezés (JSON)"
            description="Forrás → Cél mező párok"
          >
            <textarea
              value={node.data.config?.mapping || ''}
              onChange={(e) => updateConfig('mapping', e.target.value)}
              placeholder={'{\n  "oldName": "newName",\n  "customer.email": "email"\n}'}
              rows={6}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white font-mono text-sm"
            />
          </ConfigField>
        )}

        {node.data.config?.transformationType === 'group' && (
          <ConfigField
            label="Csoportosítási mező"
            description="Melyik mező alapján csoportosítson"
          >
            <input
              type="text"
              value={node.data.config?.groupBy || ''}
              onChange={(e) => updateConfig('groupBy', e.target.value)}
              placeholder="category, type, status..."
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            />
          </ConfigField>
        )}

        {node.data.config?.transformationType === 'aggregate' && (
          <ConfigField
            label="Aggregációs függvény"
            description="Milyen művelet"
          >
            <select
              value={node.data.config?.aggregateFunction || 'sum'}
              onChange={(e) => updateConfig('aggregateFunction', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            >
              <option value="sum">Összeg (sum)</option>
              <option value="avg">Átlag (avg)</option>
              <option value="min">Minimum (min)</option>
              <option value="max">Maximum (max)</option>
              <option value="count">Darabszám (count)</option>
            </select>
          </ConfigField>
        )}
      </ConfigSection>

      <div className="bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-200 dark:border-cyan-800 rounded-md p-3">
        <div className="text-xs text-cyan-700 dark:text-cyan-300">
          <strong>🔄 Adatátalakítás:</strong>
          <br />• Komplex adatstruktúrák átalakítása
          <br />• Eredmény: <code>{'{{output}}'}</code>
          <br />• Példa: Mező átnevezés, csoportosítás
        </div>
      </div>
    </div>
  );
};

export default DataTransformConfig;
